import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useApi } from '@root/src/web/lib/useApi';
import { Placeholder } from '@root/src/web/components/Placeholder';
import { MatchTabs } from './MatchTabs';
const Loading = () => _jsx(Placeholder, { height: 40 }, void 0);
export const GetMatchTabs = ({ matchUrl, format }) => {
    const { data, error, loading } = useApi(matchUrl);
    if (loading)
        return _jsx(Loading, {}, void 0);
    if (error) {
        // Send the error to Sentry and then prevent the element from rendering
        window.guardian.modules.sentry.reportError(error, 'match-tabs');
        return null;
    }
    if (data && data.minByMinUrl && data.reportUrl) {
        return (_jsx(MatchTabs, { minByMinUrl: data.minByMinUrl, reportUrl: data.reportUrl, format: format }, void 0));
    }
    return null;
};
